import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogHome.css';

const BlogHome = ({ blogs }) => {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');

  const categories = [...new Set(blogs.map(b => b.category))];
  const filtered = blogs.filter(b =>
    (b.title.toLowerCase().includes(search.toLowerCase()) || b.content.toLowerCase().includes(search.toLowerCase()))
    && (category ? b.category === category : true)
  );

  return (
    <div className="blog-home">
      <h1>📰 Company Blog</h1>
      <div className="filters">
        <input placeholder="Search blogs..." value={search} onChange={e => setSearch(e.target.value)} />
        <select value={category} onChange={e => setCategory(e.target.value)}>
          <option value="">All Categories</option>
          {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
        </select>
      </div>

      <div className="blog-grid">
        {filtered.map(blog => (
          <Link key={blog.id} to={`/blogs/${blog.slug}`} className="blog-card">
            {blog.coverImage && <img src={blog.coverImage} alt={blog.title} />}
            <div className="blog-content">
              <span className="badge">{blog.category}</span>
              <h3>{blog.title}</h3>
              <p><i>{blog.date}</i></p>
              <div dangerouslySetInnerHTML={{ __html: blog.content.slice(0, 100) + '...' }} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogHome;
